import API from "@/api";

const state = {
  authorCourses: [],
};

const mutations = {
  SET_AUTHOR_COURSES_LIST(store, payload) {
    store.authorCourses = payload;
  },
};

const actions = {
  getAuthorCourses({ commit }) {
    return new Promise((resolve, reject) => {
      API.get(`api/courses/external`)
        .then((response) => {
          commit("SET_AUTHOR_COURSES_LIST", response.data.data);
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  loadCourseById(_, data) {
    return new Promise((resolve, reject) => {
      API.get(`api/courses/external/${data.id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
